/**
 * @module state/rootReducer
 * Root reducer for the Redux store.
 * Delegates to individual `state/<application>/reducer.js`.
 * We use a solution that looks a bit like Redux's `combineReducers`,
 *   but deals with Immutable state.
 */

import {routerReducer} from "react-router-redux";
import {Map} from "immutable";

import appReducer from "state/app/reducer"
import teachersReducer from "state/teachers/reducer"
import schoolmoneyReducer from "state/school_money/reducer"

const initialState = new Map();
// slice state and delegate to each reducer.
export default function(state = initialState, action) {

  return state
    .set("app",          appReducer(state.get("app"), action))
    .set("teachers",     teachersReducer(state.get("teachers"), action))
    .set("school_money", schoolmoneyReducer(state.get("school_money"), action))
    .set("router",       routerReducer(state.get("router"), action))
}



// WEBPACK FOOTER //
// ./src/state/rootReducer.js